export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.hook('apollo:auth', ({ client, token }) => {
    const cookie = computed(() => useAuthStore().token)
    token.value = cookie.value
  })
})
